import { TextSelection } from '@tiptap/pm/state'

export function shouldShowTextFormattingBubble(selection) {
  return selection instanceof TextSelection && !selection.empty
}

export function findFirstTextSelection(doc) {
  if (!doc) return null

  let textSelection = null

  doc.descendants((node, pos) => {
    if (textSelection) return false
    if (!node.isTextblock) return true

    try {
      textSelection = TextSelection.create(doc, pos + 1)
    } catch {
      textSelection = null
    }

    return false
  })

  return textSelection
}
